module.exports = __webpack_public_path__ + "static/media/Vindermere New Hero.c40a266a.jpg";